"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VDraggableDialog = void 0;
var react_1 = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var react_rnd_1 = require("react-rnd");
var lodash_1 = require("lodash");
var styled_1 = require("./styled");
var VDraggable = function (props) {
    var _a = (0, react_1.useState)(11), reference = _a[0], setReference = _a[1];
    var rnd = null;
    var windowsWidth = window.innerWidth ||
        document.documentElement.clientWidth ||
        document.getElementsByTagName('body')[0].clientWidth;
    var windowsHeight = window.innerHeight ||
        document.documentElement.clientHeight ||
        document.getElementsByTagName('body')[0].clientHeight;
    var _b = (0, react_1.useState)({
        x: -1,
        y: -1
    }), position = _b[0], setPositions = _b[1];
    var _c = (0, react_1.useState)(), dimension = _c[0], setDimension = _c[1];
    var idDialog = (0, react_1.useMemo)(function () { return (0, lodash_1.uniqueId)(); }, [dimension]);
    var classNameDialog = (0, react_1.useMemo)(function () {
        return Math.random()
            .toString(36)
            .substring(7);
    }, [dimension]);
    (0, react_1.useEffect)(function () {
        var content = document.getElementById(idDialog);
        var element = content.getElementsByClassName('move-dialog-header')[0];
        if (props.isOpen) {
            if (dimension) {
                rnd.updateSize({ width: dimension.width, height: dimension.height });
            }
            else {
                setDimension({
                    width: element.parentNode.clientWidth,
                    height: element.parentNode.clientHeight
                });
            }
        }
        if (props.isOpen && position.x === -1 && position.y === -1) {
            if (dimension) {
                setPositions({
                    x: Math.max((windowsWidth - dimension.width) / 2, 0),
                    y: Math.max((windowsHeight - dimension.height) / 2, 0)
                });
            }
        }
        onChangeIndex();
    });
    var onChangeIndex = function () {
        if (props.isOpen) {
            var body = document.querySelectorAll('.gsi-div-move-dialog');
            var modal_1 = document.getElementById(idDialog);
            var newIndex_1 = reference;
            (0, lodash_1.forEach)(body, function (m) {
                if (modal_1 !== m) {
                    var st = window.getComputedStyle(m);
                    newIndex_1 =
                        Number(st.zIndex) > newIndex_1 ? Number(st.zIndex) : newIndex_1;
                }
            });
            if (newIndex_1 !== reference) {
                setReference(newIndex_1 + 1);
            }
        }
    };
    var rectifyPosition = function (e, d) {
        var pos = { x: d.x, y: d.y };
        setPositions(pos);
    };
    var resetPosition = function () { return setPositions({ x: -1, y: -1 }); };
    return (react_1.default.createElement("div", { id: idDialog, style: {
            top: 0,
            left: 0,
            position: 'fixed',
            zIndex: reference,
            width: '100%',
            height: '100%',
            display: "".concat(!props.isOpen ? 'none' : ''),
            backgroundColor: 'rgba(0,0,0,0.3)',
            paddingBottom: '50px'
        }, className: "gsi-div-move-dialog gsi-".concat(classNameDialog) },
        react_1.default.createElement(react_rnd_1.Rnd, { ref: function (c) {
                rnd = c;
            }, enableResizing: {
                bottomLeft: false,
                bottomRight: false,
                topLeft: false,
                topRight: false
            }, position: __assign({}, position), onDragStop: function (e, d) {
                rectifyPosition(e, d);
            }, bounds: 'window', onDragStart: function () {
                onChangeIndex();
            }, onDrag: function (e, d) {
                rectifyPosition(e, d);
            }, default: __assign(__assign({}, position), { width: 'auto', height: 'auto' }), enableUserSelectHack: true, dragHandleClassName: "gsi-div-move-dialog.gsi-".concat(classNameDialog, " .move-dialog-header") },
            react_1.default.createElement(styled_1.DialogStyled, { hasBackdrop: false, usePortal: false, autoFocus: false, canOutsideClickClose: false, canEscapeKeyClose: false, style: { paddingBottom: '0' }, isOpen: props.isOpen, children: props.children, onClose: props.onClose, onClosed: resetPosition, transitionDuration: 10, enforceFocus: false, width: dimension && dimension.width, height: dimension && dimension.height }))));
};
var VDraggableDialog = function (props) {
    return react_dom_1.default.createPortal(react_1.default.createElement(VDraggable, __assign({}, props)), document.body);
};
exports.VDraggableDialog = VDraggableDialog;
